import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "block-pageHeader" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "dt-topLink" }
const _hoisted_4 = {
  key: 0,
  style: {"padding-top":"0"},
  class: "block-pageHeader__title mt30"
}
const _hoisted_5 = { class: "container" }
const _hoisted_6 = {
  key: 1,
  class: "dt__itemList"
}
const _hoisted_7 = { class: "dt__itemList-control dt__itemList-control_desktop" }
const _hoisted_8 = { class: "dt__itemList-control-wrapper" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "dt-mapIcon" }, null, -1 /* HOISTED */)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "Показать на карте", -1 /* HOISTED */)
const _hoisted_11 = { class: "dt__itemList-control dt__itemList-control_mobile" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "dt-mapIcon" }, null, -1 /* HOISTED */)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "Показать на карте", -1 /* HOISTED */)
const _hoisted_14 = { class: "dt__itemList-control-wrapper" }
const _hoisted_15 = { class: "container" }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  key: 0,
  class: "block-alert block-alert_nobtn mt30"
}
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<div class=\"block-alert__icon\"><svg height=\"136pt\" viewBox=\"-1 0 136 136.21852\" width=\"136pt\"><path fill=\"#ffffff\" d=\"M 93.148438 80.832031 C 109.5 57.742188 104.03125 25.769531 80.941406 9.421875 C 57.851562 -6.925781 25.878906 -1.460938 9.53125 21.632812 C -6.816406 44.722656 -1.351562 76.691406 21.742188 93.039062 C 38.222656 104.707031 60.011719 105.605469 77.394531 95.339844 L 115.164062 132.882812 C 119.242188 137.175781 126.027344 137.347656 130.320312 133.269531 C 134.613281 129.195312 134.785156 122.410156 130.710938 118.117188 C 130.582031 117.980469 130.457031 117.855469 130.320312 117.726562 Z M 51.308594 84.332031 C 33.0625 84.335938 18.269531 69.554688 18.257812 51.308594 C 18.253906 33.0625 33.035156 18.269531 51.285156 18.261719 C 69.507812 18.253906 84.292969 33.011719 84.328125 51.234375 C 84.359375 69.484375 69.585938 84.300781 51.332031 84.332031 C 51.324219 84.332031 51.320312 84.332031 51.308594 84.332031 Z M 51.308594 84.332031 \"></path></svg></div><div class=\"block-alert__title\"> Данные не найдены </div><div class=\"block-alert__description\"> Не удалось найти информацию. Измените параметры фильтрации для данной категории. </div>", 3)
const _hoisted_21 = [
  _hoisted_18
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_skeleton_title = _resolveComponent("skeleton-title")!
  const _component_skeleton_list_control = _resolveComponent("skeleton-list-control")!
  const _component_item_list_filter = _resolveComponent("item-list-filter")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_sort_component = _resolveComponent("sort-component")!
  const _component_skeleton_list = _resolveComponent("skeleton-list")!
  const _component_preview_card = _resolveComponent("preview-card")!
  const _component_paginate = _resolveComponent("paginate")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (!this.loading)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "block-pageHeader__img block-pageHeader__img_digitalTwin",
            style: _normalizeStyle({backgroundImage: 'url(' + this.page.image.url + ')'})
          }, null, 4 /* STYLE */))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("a", {
            class: "block-btnNavBack",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
          }),
          (!this.loading)
            ? (_openBlock(), _createElementBlock("h1", _hoisted_4, _toDisplayString(this.page.name), 1 /* TEXT */))
            : (_openBlock(), _createBlock(_component_skeleton_title, { key: 1 }))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (this.loading)
        ? (_openBlock(), _createBlock(_component_skeleton_list_control, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_item_list_filter, {
                  filters: this.page.filters,
                  onApply: _ctx.onApplyFilter,
                  onReset: _ctx.onResetFilter
                }, null, 8 /* PROPS */, ["filters", "onApply", "onReset"]),
                _createVNode(_component_router_link, {
                  to: {name: 'page-map', params: this.pageIdentity},
                  class: "dt__iconNav"
                }, {
                  default: _withCtx(() => [
                    _hoisted_9,
                    _hoisted_10
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["to"])
              ]),
              _createVNode(_component_sort_component, {
                modelValue: this.page.sortMode,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((this.page.sortMode) = $event)),
                onApply: _ctx.onApplySort,
                list: this.page.allowedSortModes
              }, null, 8 /* PROPS */, ["modelValue", "onApply", "list"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_router_link, {
                to: {name: 'page-map', params: this.pageIdentity},
                class: "dt__iconNav"
              }, {
                default: _withCtx(() => [
                  _hoisted_12,
                  _hoisted_13
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["to"]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_item_list_filter, {
                  filters: this.page.filters,
                  onApply: _ctx.onApplyFilter,
                  onReset: _ctx.onResetFilter
                }, null, 8 /* PROPS */, ["filters", "onApply", "onReset"]),
                _createVNode(_component_sort_component, {
                  modelValue: this.page.sortMode,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((this.page.sortMode) = $event)),
                  onApply: _ctx.onApplySort,
                  list: this.page.allowedSortModes
                }, null, 8 /* PROPS */, ["modelValue", "onApply", "list"])
              ])
            ])
          ]))
    ]),
    _createElementVNode("div", _hoisted_15, [
      (_ctx.loadingPageItems)
        ? (_openBlock(), _createBlock(_component_skeleton_list, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_16, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fetchPageItems, (item) => {
              return (_openBlock(), _createBlock(_component_preview_card, {
                item: item,
                "page-identity": _ctx.pageIdentity,
                onApplyFilter: _ctx.onSetFilter
              }, null, 8 /* PROPS */, ["item", "page-identity", "onApplyFilter"]))
            }), 256 /* UNKEYED_FRAGMENT */)),
            (_ctx.fetchPageItems.total === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_21))
              : _createCommentVNode("v-if", true)
          ])),
      _createVNode(_component_paginate, {
        modelValue: _ctx.pageNumber,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.pageNumber) = $event)),
        list: _ctx.fetchPageItems,
        onChangePage: _ctx.changePage
      }, null, 8 /* PROPS */, ["modelValue", "list", "onChangePage"])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}